import GuestDocuments from "@/components/shared/GuestDocuments";
import GuestForm from "@/components/shared/GuestForm";
import GuestListv2 from "@/components/shared/GuestListv2";
import GuestOtherInfo from "@/components/shared/GuestOtherInfo";
import MobileSteps from "@/components/shared/MobileSteps";
import Payment from "@/components/shared/Payment";
import Signaturev2 from "@/components/shared/Signaturev2";
import { FieldsService } from "smck-service";
import Vue from "vue";

export default {
  components: {
    GuestForm,
    GuestOtherInfo,
    GuestListv2,
    MobileSteps,
    GuestDocuments,
    Payment,
    Signaturev2
  },
  props: [
    "activeTab",
    "isMaster",
    "enableZooxpay",
    "enabledScanTab",
    "enableRecognition",
    "currentMobileStep",
    "currentCompany",
    "currentReservation",
    "qualifiedGuest",
    "chargeToPayAtCheckin",
    "fieldSettingsData",
    "emailNotRequired",
    "jobNotRequired",
    "tabHistory",
    "orientationTexts"
  ],
  data() {
    return {
      otherInfoVisible: true,
      fieldsService: new FieldsService(Vue)
    };
  },
  computed: {
    showPayment() {
      return (
        this.currentMobileStep === 3 &&
        this.enableZooxpay &&
        this.chargePayAtCheckin !== null &&
        this.isMaster
      );
    }
  },
  methods: {
    hideOtherInfo() {
      this.otherInfoVisible = false;
    },
    showOtherInfo() {
      this.otherInfoVisible = true;
    },
    updateVuexGuest(guest) {
      this.$emit("update-vuex-guest", guest);
    }
  }
};
